import { render, staticRenderFns } from "./TableOrderCreateOrEdit.vue?vue&type=template&id=594d9252&"
import script from "./TableOrderCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./TableOrderCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./TableOrderCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports